module.exports = {
  EOF: 0,
  DELIMITER: 1,
  NUMBER: 2,
  STRING: 3,
  SYMBOL: 4
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/mr-parser/lib/token-type.js
// module id = +lBY
// module chunks = 0